import styled from 'styled-components';

export const Container = styled.div`
  margin-right: 16px;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  p {
    font-size: 14px;
    font-weight: 500;
  }

  .right_content {
    width: 82%;
  }

  .ant-input-disabled {
    color: #202020;
  }

  svg {
    * {
      pointer-events: none;
    }
  }
`;

export const Items = styled.div`
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  margin-bottom: 24px;

  p {
    font-size: 14px;
    font-weight: 500;
  }

  .right_content {
    width: 82%;
  }

  .ant-input-disabled {
    color: #202020;
  }

  svg {
    * {
      pointer-events: none;
    }
  }
`;
